import L from '@anlan/gs-map';
import type { ImageOverlay as LeafletImageOverlay, ImageOverlayOptions, LatLngBoundsExpression, SVGOverlay as LeafletSVGOverlay, VideoOverlay as LeafletVideoOverlay } from '@anlan/gs-map';
import type { InteractiveLayerProps } from './layer';
const LatLngBounds = L.LatLngBounds;

export interface MediaOverlayProps extends ImageOverlayOptions, InteractiveLayerProps {
    bounds: LatLngBoundsExpression
}

export function updateMediaOverlay<E extends LeafletImageOverlay | LeafletSVGOverlay | LeafletVideoOverlay, P extends MediaOverlayProps>(overlay: E, props: P, prevProps: P) {
    if (props.bounds instanceof LatLngBounds && props.bounds !== prevProps.bounds) {
        overlay.setBounds(props.bounds);
    }
    if (props.opacity != null && props.opacity !== prevProps.opacity) {
        overlay.setOpacity(props.opacity);
    }
    if (props.zIndex != null && props.zIndex !== prevProps.zIndex) {
        overlay.setZIndex(props.zIndex);
    }
}
